import { AttachDocsContentProps } from './attach-docs-content.types';

export const AttachDocsContentPreset: Partial<AttachDocsContentProps> = {
  onClose: () => {},
  onConfirm: () => {},
  show: false,
};
